import { Flex, Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import CircularProgress from "src/components/CircularProgress";
import { Subtitle } from "src/atoms/typography";
import Fade from "src/components/Fade";
import Slide from "src/components/Slide";
import InsideCircularProgress from "./InsideCircularProgress";

function statusMapper(recorderStatus) {
  return {
    initial: "hidden",
    waitingForResponse: "hidden",
    recording: "running",
    waitingForThumbnail: "restingCurrent",
    finished: "restingEnd"
  }[recorderStatus];
}

export default function VideoRecordingController({ mediaCapturer }, ref) {
  const { t } = useTranslation();
  const {
    stopRecording,
    state,
    getRecordingProgress,
    onRecordingLimitReached
  } = mediaCapturer;

  return (
    <Box position="fixed" left="50%" transform="translateX(-50%)" bottom="14px">
      <Slide
        appear
        unmountOnExit
        in={
          state.recorder.status !== "initial" &&
          state.recorder.status !== "finished"
        }
        offsetY="120px"
        duration={{ enter: 0.3, exit: 0 }}
      >
        <Flex flexDirection="column" alignItems="center">
          <Fade
            in={state.recorder.status === "recording"}
            appear
            duration={{
              enter: 0.3,
              exit: 0
            }}
          >
            <Subtitle mb="12px" color="white">
              {t("recordingInProgress")}
            </Subtitle>
          </Fade>
          <Flex position="relative" width="56px" height="56px">
            <Fade
              in={state.recorder.status !== "initial"}
              appear
              duration={{
                enter: 0.3,
                exit: 0
              }}
            >
              <CircularProgress
                size="100%"
                borderWidth={2}
                color="white"
                status={statusMapper(state.recorder.status)}
                getProgress={getRecordingProgress}
                onFinish={onRecordingLimitReached}
              ></CircularProgress>
            </Fade>
            <InsideCircularProgress
              status={state.recorder.status}
              stopRecording={stopRecording}
            />
          </Flex>
        </Flex>
      </Slide>
    </Box>
  );
}
